import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ArrowDownToLine, ArrowUpToLine, Pencil } from "lucide-react";
import { MdCancel } from "react-icons/md";

import css from './SemiFinishedSemiFinishModal.module.css';
import { semiFinishedSemiFinishedActions } from "../../../../store/slices/semiFinished-slice";
import { SemiFinishedUpdateSemiFinishedModal } from "../SemiFinishedAddSemiFinishedModal/SemiFinishedUpdateSemiFinishedModal";


const SemiFinishedSemiFinishModal = ({ data, index }) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const { id, name, weight, cost, weightNetto, energy, fats, proteins, carbohydrates, child } = data;

    const { semiFinishedSemiFinishedForModalArray } = useSelector(store => store.semiFinishedSemiFinished);

    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name['en'];

    // Nutrients: manually added items have top-level energy/fats/proteins/carbohydrates
    // API items store them in child.{energy,fats,...}
    const displayEnergy = energy ?? child?.energy ?? 0;
    const displayFats = fats ?? child?.fats ?? 0;
    const displayProteins = proteins ?? child?.proteins ?? 0;
    const displayCarbohydrates = carbohydrates ?? child?.carbs ?? 0;

    const [isOpenUpdate, setIsOpenUpdate] = useState(false);

    const deleteSemiFinishedSM = () => {
        dispatch(semiFinishedSemiFinishedActions.removeSemiFinishedForModal(id));
    };

    const handleUpClick = () => {
        if (index === 0) return;
        const newArray = [...semiFinishedSemiFinishedForModalArray];
        newArray.splice(index, 1);
        newArray.splice(index - 1, 0, semiFinishedSemiFinishedForModalArray[index]);
        dispatch(semiFinishedSemiFinishedActions.updateSemiFinishedSemiFinishedForModal(newArray));
    };

    const handleDownClick = () => {
        if (index === semiFinishedSemiFinishedForModalArray.length - 1) return;
        const newArray = [...semiFinishedSemiFinishedForModalArray];
        newArray.splice(index, 1);
        newArray.splice(index + 1, 0, semiFinishedSemiFinishedForModalArray[index]);
        dispatch(semiFinishedSemiFinishedActions.updateSemiFinishedSemiFinishedForModal(newArray));
    };

    return (
        <section className={css.wrap}>
            <div className={css.product}>
                {displayName}

                <div className={css.nutritionGrid}>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>E:</span>
                        <span className={css.nutritionValue}>{displayEnergy || 0} kcal</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>P:</span>
                        <span className={css.nutritionValue}>{displayProteins || 0} g</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>F:</span>
                        <span className={css.nutritionValue}>{displayFats || 0} g</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>C:</span>
                        <span className={css.nutritionValue}>{displayCarbohydrates || 0} g</span>
                    </div>
                </div>
            </div>
            <div className={css.weight}>{weight}</div>
            <div className={css.weightNetto}>{weightNetto}</div>
            <div className={css.price}>{cost}</div>
            <div className={css.index}>
                {index > 0 && <ArrowUpToLine size={16} onClick={handleUpClick} />}
                {index !== semiFinishedSemiFinishedForModalArray.length - 1 && (
                    <ArrowDownToLine size={16} onClick={handleDownClick} />
                )}
            </div>
            <div className={css.actions}>
                <div className={css.updateButton} onClick={() => setIsOpenUpdate(true)}>
                    <Pencil size={16} />
                </div>
                <div className={css.deleteButton} onClick={deleteSemiFinishedSM}>
                    <MdCancel size={16} />
                </div>
            </div>

            {isOpenUpdate && (
                <SemiFinishedUpdateSemiFinishedModal
                    semiFinishedId={data.semiFinishedId ?? data.childId ?? id}
                    setUpdateOpen={setIsOpenUpdate}
                    weight={weight}
                    weightNetto={weightNetto}
                />
            )}
        </section>
    );
};

export default React.memo(SemiFinishedSemiFinishModal);
